import {
  CalciteButton,
  CalcitePanel,
  CalcitePopover
} from 'components/Calcite';
import DataGrid from 'components/DataGrid';
import { DataGridCell } from 'components/DataGrid';
import styled from 'styled-components';
import { unitCalc } from 'utils/cssUtils';

export const CodeDataGridCell = styled(DataGridCell)`
  font-family: ${({ theme }) => theme.font.codeFamily};
`;

export const FixedHelperDataGrid = styled(DataGrid)`
  table-layout: fixed;

  td {
    padding-top: ${({ theme }) => unitCalc(theme.baseline, 8, '/')};
    padding-bottom: ${({ theme }) => unitCalc(theme.baseline, 8, '/')};

    &:last-child {
      padding-right: 0;
    }
  }
`;

export const StyledCaption = styled.caption`
  caption-side: top;
  text-align: center;
  font-size: 1.1rem;
  margin-bottom: ${({ theme }) => unitCalc(theme.baseline, 4, '/')};
  font-weight: 300;
`;

export const StyledCodeCopy = styled.span`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.font.codeFamily};
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 175ms linear;

  > svg {
    margin-left: ${({ theme }) => unitCalc(theme.baseline, 3, '/')};
  }

  &:hover {
    opacity: 1;
  }
`;

export const StyledDataGridCell = styled(DataGridCell)`
  width: 130px;
`;

export const StyledHelperPopover = styled(CalcitePopover).attrs({
  autoClose: true,
  overlayPositioning: 'fixed'
})``;

export const StyledHelperButton = styled(CalciteButton).attrs({
  alignment: 'start',
  appearance: 'transparent',
  scale: 's'
})`
  width: fit-content;
`;

export const StyledHelperPanel = styled(CalcitePanel)`
  max-width: 610px;
  padding: ${({ theme }) => unitCalc(theme.baseline, 2, '/')};
`;

export const StyledHelperP = styled.p`
  padding: 0 ${({ theme }) => unitCalc(theme.baseline, 4, '/')};
`;
